import Page from "webPage/Page";
import {handleNewsTrack} from "pages/homepage";

Page.register("single", () => {
    handleNewsTrack();
});


